/**
 * YulOnTap UI Polish — shared animated primitives (v2.7.0)
 * Purely visual; no logic or data behavior.
 */
import { cn } from '../../lib/utils';

/** Animated confirmation checkmark (stroke draws in ~200ms). */
export function SuccessCheck({ size = 48, className = '', colorClass = 'text-emerald-500', strokeWidth = 3 }) {
    const d = size;
    return (
        <svg
            width={d} height={d}
            viewBox="0 0 64 64"
            className={cn('yp-check-svg', colorClass, className)}
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            aria-label="Success"
        >
            <circle className="yp-check-circle-path" cx="32" cy="32" r="28" />
            <path className="yp-check-tick-path" d="M20 33 L29 42 L45 24" />
        </svg>
    );
}

/** Simple skeleton placeholder (width/height via className). */
export function Skeleton({ className = '' }) {
    return <div className={cn('yp-skeleton h-4 w-full', className)} aria-hidden="true" />;
}

/** Pulsing brand icon — replaces static spinners for key flows. */
export function PulseIcon({ icon: Icon, size = 28, className = '', colorClass = 'text-emerald-500' }) {
    return (
        <span className={cn('inline-flex items-center justify-center yp-icon-pulse', colorClass, className)}>
            <Icon size={size} />
        </span>
    );
}

/** Skeleton list — for data tables while loading. */
export function SkeletonList({ rows = 4, className = '' }) {
    return (
        <div className={cn('space-y-2', className)} aria-hidden="true">
            {Array.from({ length: rows }).map((_, i) => (
                <Skeleton key={i} className="h-10 w-full" />
            ))}
        </div>
    );
}
